// extracted by mini-css-extract-plugin
export default {"setting-dropdown-item":"product-data_setting-dropdown-item__bPfLr","date-flex":"product-data_date-flex__gQqIS"};